import React, { useState } from "react";

import {
    ConditionalShopTileBody,
    TsicommonCms5,
    templates,
} from "@reactivated";

import { CompareGrid } from "../apps/shop-compare/CompareGrid";
import { CompareTileType } from "../apps/shop-compare/ShopCompareTypes";

export type CompareTileBlockWithDisabled = TsicommonCms5 & {
    disabled: boolean;
};

export type DropdownHeadersType = {
    header: string | undefined;
    id: number | undefined;
    children: CompareTileBlockWithDisabled[] | undefined;
}[];

export type AllTileModelsType = {
    shop_tile_title: string | undefined;
    title: string | undefined;
    product: number | undefined;
};

export type GroupedTileModelsType = Record<string, AllTileModelsType[]>;

const groupModelsByShopTileTitle = (
    models: AllTileModelsType[],
): GroupedTileModelsType => {
    return models.reduce((groups, model) => {
        if (!model.product) return groups;

        const groupTitle = model.shop_tile_title || "Other";
        if (!groups[groupTitle]) {
            groups[groupTitle] = [];
        }
        groups[groupTitle].push(model);
        return groups;
    }, {} as GroupedTileModelsType);
};

export const Template = (props: templates.ShopTileTemplate) => {
    const getInitialSelectedCompareTiles = () => {
        const initialSeenProductIds = new Set<number>();
        return props.shop_tile.compare_tiles.value
            .map((t) => t.value?.product || 0)
            .filter((productId) => {
                if (productId && !initialSeenProductIds.has(productId)) {
                    initialSeenProductIds.add(productId);
                    return true;
                }
                return false;
            });
    };

    const [selectedCompareTiles, setSelectedCompareTiles] = useState<number[]>(
        getInitialSelectedCompareTiles(),
    );

    if (!props.tileset?.shop_tiles || !props.shop_tile) {
        return null;
    }

    const compareTiles: CompareTileType[] =
        props.tileset.shop_tiles.value.reduce((acc, t) => {
            const tile = t.value.shop_tile;
            acc.push(
                ...(tile?.compare_tiles?.map(
                    (ct) => ct.value as CompareTileType,
                ) || []),
            );
            return acc;
        }, [] as CompareTileType[]);

    // Extract the relevant information (title, product id) from the tileset to populate the compare dropdowns
    const allTileModels: AllTileModelsType[] = [];
    const tileSeenProductIds = new Set<number>();

    props.tileset.shop_tiles.value.map((shopTile: ConditionalShopTileBody[0]) =>
        shopTile.value.shop_tile?.compare_tiles?.map((t) => {
            const productId = t.value.product;
            if (productId && !tileSeenProductIds.has(productId)) {
                tileSeenProductIds.add(productId);
                allTileModels.push({
                    shop_tile_title: shopTile.value.shop_tile?.title,
                    title: t.value.title || "",
                    product: productId,
                });
            }
        }),
    );

    const groupedModels = groupModelsByShopTileTitle(allTileModels);

    const handleSelectProductTile = (newTile: number, column: number) => {
        setSelectedCompareTiles((prev) => {
            const newTiles = [...prev];
            newTiles[column] = newTile;
            return newTiles;
        });
    };

    return (
        <div>
            <CompareGrid
                compareTiles={compareTiles}
                compareFeatures={
                    props.tileset.compare_features?.value.map(
                        (cf) => cf.value,
                    ) || []
                }
                groupedDropdownModels={groupedModels}
                handleSelectProduct={handleSelectProductTile}
                selectedProducts={selectedCompareTiles}
            />
        </div>
    );
};
